import { Text } from '@avanta/shared/components/Text';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Calendar, FileText, Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ENTERPRISE_APPOINTMENT_STATUS } from 'constants/appointments';
import { useAppointmentAction } from 'hooks/useAppointmentAction';
import { type Appointment } from 'types/appointments';
import { APPOINTMENT_ACTION_OPTIONS } from './constants';

interface SessionTableActionsProps {
  appointment: Appointment;
}

export const SessionTableActions = ({
  appointment,
}: SessionTableActionsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const { runAppointmentAction, isReportPending } = useAppointmentAction(
    APPOINTMENT_ACTION_OPTIONS
  );
  const { status } = appointment;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    runAppointmentAction(appointment);
  };

  if (status === ENTERPRISE_APPOINTMENT_STATUS.CANCELLED) {
    return (
      <Button variant="terciary" icon="leading" className="w-full" onClick={handleClick}>
        <Info />
        {t('AppointmentsHistory.actions.details')}
      </Button>
    );
  }

  if (status === ENTERPRISE_APPOINTMENT_STATUS.DONE) {
    return (
      <div data-no-row-action>
        <Text variant="text-xs-regular" className="text-denim-800 text-center">
          {t('SessionsPage.actions.noReport')}
        </Text>
      </div>
    );
  }

  if (status === ENTERPRISE_APPOINTMENT_STATUS.COMPLETED) {
    return (
      <Button
        variant="terciary"
        icon="leading"
        className="w-full"
        isLoading={isReportPending}
        onClick={handleClick}
      >
        <FileText />
        {t('AppointmentsHistory.actions.report')}
      </Button>
    );
  }

  return (
    <Button variant="terciary" icon="leading" className="w-full" onClick={handleClick}>
      <Calendar />
      {t('InsuredPersonsList.manageAppointment.cta')}
    </Button>
  );
};
